var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "m23.007 5.686-5.213 3.212-4.998-6.667a.216.216 0 0 0-.345 0L7.455 8.898 2.24 5.686a.216.216 0 0 0-.327.212L3.96 21.45c.029.211.211.375.428.375h16.476c.214 0 .4-.16.426-.375l2.046-15.552a.218.218 0 0 0-.33-.212m-3.375 14.307H5.615L4.174 9.027l3.744 2.306 4.707-6.279 4.706 6.279 3.745-2.306zm-7.007-8.079a3.02 3.02 0 0 0-3.016 3.016 3.02 3.02 0 0 0 3.016 3.016 3.02 3.02 0 0 0 3.016-3.016 3.02 3.02 0 0 0-3.016-3.016m0 4.31a1.294 1.294 0 0 1 0-2.588 1.294 1.294 0 0 1 0 2.588"
  })));
};
export default SvgCrown;